import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { StyleSheet, css } from 'aphrodite';

import images from '../../constants/images';

const Header = () => {
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setAnimate(true), 120);
    return () => clearTimeout(timer);
  }, []);

  return (
    <header className={css(styles.header)} id="home">
      <div className={css(styles.info, animate && styles.fadeLeft)}>
        <p className={css(styles.eyebrow)}>Menlyn Maine · Pretoria</p>
        <h1 className={css(styles.title)}>A table worth <em>remembering.</em></h1>
        <p className={css(styles.description)}>
          African soul, Mediterranean ease and a kitchen that cooks with confidence.
          Come for the plate. Stay for the feeling.
        </p>
        <div className={css(styles.actions)}>
          <Link to="/reservation" className={css(styles.primaryAction)}>
            Reserve your table <HiOutlineArrowNarrowRight />
          </Link>
          <Link to="/menu" className={css(styles.secondaryAction)}>Explore the menu</Link>
        </div>
        <div className={css(styles.details)}>
          <span>Lunch · Dinner · Cocktails</span>
          <span>Open daily</span>
        </div>
      </div>

      <div className={css(styles.imageContainer, animate && styles.fadeRight)}>
        <img src={images.meal34} alt="A beautifully plated Fortress Restaurant dish" className={css(styles.image)} />
        <div className={css(styles.imageLabel)}>
          <span>Fortress signature</span>
          <strong>Made to linger over</strong>
        </div>
      </div>
    </header>
  );
};

const styles = StyleSheet.create({
  header: { minHeight: '100vh', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 'clamp(2rem,6vw,7rem)', background: 'var(--color-cream)', padding: '10rem clamp(1.5rem,6vw,6.5rem) 5rem', overflow: 'hidden', '@media (max-width:950px)': { flexDirection: 'column', textAlign: 'center', padding: '8.5rem 2rem 4rem', gap: '3rem' } },
  info: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '1.6rem', zIndex: 2, '@media (max-width:950px)': { alignItems: 'center' } },
  eyebrow: { fontFamily: 'var(--font-ui)', color: 'var(--color-green)', fontSize: '.73rem', fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase' },
  title: { fontFamily: 'var(--font-base)', fontSize: 'clamp(3.5rem,6.5vw,6.8rem)', fontWeight: 500, color: 'var(--color-green)', lineHeight: .98, letterSpacing: '-.045em', maxWidth: '720px', '@media (max-width:500px)': { fontSize: '3.2rem' } },
  description: { color: 'var(--color-gray)', fontSize: '1.05rem', fontFamily: 'var(--font-alt)', lineHeight: 1.75, maxWidth: '560px', '@media (max-width:650px)': { fontSize: '.95rem' } },
  actions: { display: 'flex', alignItems: 'center', gap: '1.2rem', flexWrap: 'wrap', '@media (max-width:950px)': { justifyContent: 'center' } },
  primaryAction: { display: 'inline-flex', alignItems: 'center', gap: '.8rem', padding: '1rem 1.4rem', borderRadius: '999px', background: 'var(--color-green)', color: 'var(--color-white)', fontFamily: 'var(--font-ui)', fontSize: '.75rem', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase' },
  secondaryAction: { color: 'var(--color-green)', fontFamily: 'var(--font-ui)', fontSize: '.75rem', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', borderBottom: '1px solid rgba(35,79,64,.35)', paddingBottom: '.25rem' },
  details: { display: 'flex', gap: '1.4rem', flexWrap: 'wrap', color: 'var(--color-gray)', fontFamily: 'var(--font-ui)', fontSize: '.68rem', letterSpacing: '.08em', textTransform: 'uppercase', '@media (max-width:950px)': { justifyContent: 'center' } },
  imageContainer: { flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', minWidth: 0, '@media (max-width:950px)': { width: '100%' } },
  image: { width: '100%', maxWidth: '570px', height: '72vh', objectFit: 'cover', borderRadius: '220px 220px 22px 22px', boxShadow: 'var(--shadow-soft)', '@media (max-width:950px)': { height: '60vh' }, '@media (max-width:650px)': { height: '52vh' } },
  imageLabel: { position: 'absolute', left: '-1.5rem', bottom: '2rem', padding: '1rem 1.3rem', background: 'rgba(255,253,247,.94)', borderRadius: '14px', boxShadow: '0 14px 35px rgba(23,60,50,.14)', display: 'flex', flexDirection: 'column', gap: '.2rem', color: 'var(--color-green)', fontFamily: 'var(--font-ui)', fontSize: '.66rem', letterSpacing: '.08em', textTransform: 'uppercase', '@media (max-width:650px)': { left: '.8rem', bottom: '1rem' } },
  fadeLeft: { animationName: { from: { opacity: 0, transform: 'translateY(24px)' }, to: { opacity: 1, transform: 'translateY(0)' } }, animationDuration: '.8s' },
  fadeRight: { animationName: { from: { opacity: 0, transform: 'translateY(24px)' }, to: { opacity: 1, transform: 'translateY(0)' } }, animationDuration: '1s' },
});

export default Header;
